import { Link } from "react-router-dom";

const serviceLinks = [
  { label: "网页打不开", id: "cant-open" },
  { label: "加载速度慢", id: "slow-loading" },
  { label: "换源失败", id: "source-switch" },
  { label: "收藏丢失", id: "favorites" },
  { label: "搜索无结果", id: "search" },
  { label: "登录异常", id: "login" },
];

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "使用技巧", id: "tips" },
  { label: "常见问答", id: "faq" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function Footer() {
  const goAnchor = (id: string) => {
    if (window.location.pathname !== "/") {
      window.location.href = `/#${id}`;
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
                <i className="ri-pen-nib-fill" />
              </span>
              <span className="font-display text-xl text-white">笔笔漫画网</span>
            </div>
            <p className="mt-4 text-sm leading-6 text-background-300">
              笔笔漫画网使用问题一站式帮助中心。网页打不开、加载慢、换源失败、收藏丢失、搜索无结果、登录异常，按步骤操作即可恢复顺畅阅读。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white">问题速查</h4>
            <ul className="mt-4 space-y-2.5">
              {serviceLinks.map((s) => (
                <li key={s.id}>
                  <button
                    onClick={() => goAnchor(s.id)}
                    className="text-sm text-background-300 transition-colors hover:text-secondary-300"
                  >
                    {s.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white">快速入口</h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((q) => (
                <li key={q.label}>
                  {"to" in q ? (
                    <Link
                      to={q.to as string}
                      className="text-sm text-background-300 transition-colors hover:text-secondary-300"
                    >
                      {q.label}
                    </Link>
                  ) : (
                    <button
                      onClick={() => goAnchor(q.id as string)}
                      className="text-sm text-background-300 transition-colors hover:text-secondary-300"
                    >
                      {q.label}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white">联系与支持</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" />
                support@bibi-manga.help
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line" />
                服务时间 09:00 - 21:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-chat-smile-3-line" />
                工作日当天响应
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-3">
              {["ri-wechat-line", "ri-qq-line", "ri-mail-send-line", "ri-weibo-line"].map(
                (ic) => (
                  <span
                    key={ic}
                    className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-white/10 text-base text-background-100 transition-colors hover:bg-secondary-500 hover:text-background-950"
                  >
                    <i className={ic} />
                  </span>
                ),
              )}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-sm text-background-300 sm:flex-row">
          <p>© {new Date().getFullYear()} 笔笔漫画网帮助中心 · 让每一次阅读顺畅发生</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-line text-secondary-400" />
            专注解决你的每一次使用困扰
          </p>
        </div>
      </div>
    </footer>
  );
}